import React, {
  createContext, useContext, useMemo, useState,
} from 'react';

export const ModalsContext = createContext({
  showAuthModal: false,
  showErrorModal: false,
  showEditProfile: false,
  showRegisterModal: false,
  showNavigationDrawer: false,
  showChangePasswordModal: false,
  showTicketSearchDrawer: false,
  showTicketPaymentStatus: false,
  showPasswordRecovery: false,
  showProfileDrawer: false,
  showTicketAdditionalServicesModal: false,
  bookedStatementModal: {
    show: false,
    statement: null,
  },
  ticketRefundConfirmModal: {
    show: false,
    data: null,
  },
  showTermsModal: false,
  showDeactivateModal: false,
  setShowAuthModal: () => {},
  setShowEditProfile: () => {},
  setShowRegisterModal: () => {},
  setShowNavigationDrawer: () => {},
  setShowChangePasswordModal: () => {},
  setShowTicketSearchDrawer: () => {},
  setShowTicketPaymentStatus: () => {},
  setShowPasswordRecovery: () => {},
  setShowProfileDrawer: () => {},
  setBookedStatementModal: () => {},
  setShowTicketAdditionalServicesModal: () => {},
  setShowErrorModal: () => {},
  setTicketRefundConfirmModal: () => {},
  setShowTermsModal: () => {},
  setShowDeactivateModal: () => {},
});

export const useModal = () => useContext(ModalsContext);

export function ModalsContextProvider(props) {
  const { children } = props;
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showNavigationDrawer, setShowNavigationDrawer] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showTicketSearchDrawer, setShowTicketSearchDrawer] = useState(false);
  const [showTicketPaymentStatus, setShowTicketPaymentStatus] = useState(false);
  const [showPasswordRecovery, setShowPasswordRecovery] = useState(false);
  const [showProfileDrawer, setShowProfileDrawer] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [bookedStatementModal, setBookedStatementModal] = useState({
    show: false,
    statement: null,
  });
  const [
    showTicketAdditionalServicesModal,
    setShowTicketAdditionalServicesModal,
  ] = useState({
    show: false,
    data: null,
  });
  const [ticketRefundConfirmModal, setTicketRefundConfirmModal] = useState({
    show: false,
    data: null,
  });

  const contextValue = useMemo(
    () => ({
      showAuthModal,
      showEditProfile,
      showRegisterModal,
      showNavigationDrawer,
      showChangePasswordModal,
      showTicketSearchDrawer,
      showTicketPaymentStatus,
      showPasswordRecovery,
      showProfileDrawer,
      bookedStatementModal,
      showTicketAdditionalServicesModal,
      showErrorModal,
      ticketRefundConfirmModal,
      showTermsModal,
      showDeactivateModal,
      setShowAuthModal,
      setShowEditProfile,
      setShowRegisterModal,
      setShowNavigationDrawer,
      setShowChangePasswordModal,
      setShowTicketSearchDrawer,
      setShowTicketPaymentStatus,
      setShowPasswordRecovery,
      setShowProfileDrawer,
      setBookedStatementModal,
      setShowTicketAdditionalServicesModal,
      setShowErrorModal,
      setTicketRefundConfirmModal,
      setShowTermsModal,
      setShowDeactivateModal,
    }),
    [
      showAuthModal,
      showEditProfile,
      showRegisterModal,
      showNavigationDrawer,
      showChangePasswordModal,
      showTicketSearchDrawer,
      showTicketPaymentStatus,
      showPasswordRecovery,
      showProfileDrawer,
      bookedStatementModal,
      showTicketAdditionalServicesModal,
      showErrorModal,
      ticketRefundConfirmModal,
      showTermsModal,
      showDeactivateModal,
    ],
  );

  return (
    <ModalsContext.Provider value={contextValue}>
      {children}
    </ModalsContext.Provider>
  );
}
